export const SEND_VERIFY_EMAIL = 'SEND_VERIFY_EMAIL';

export const VERIFY_EMAIL_INVALID_TOKEN = 'VERIFY_EMAIL_INVALID_TOKEN';
